import { render, staticRenderFns } from "./ManagementEntityProjects.vue?vue&type=template&id=c09c99ca&scoped=true&"
import script from "./ManagementEntityProjects.vue?vue&type=script&lang=js&"
export * from "./ManagementEntityProjects.vue?vue&type=script&lang=js&"
import style0 from "./ManagementEntityProjects.vue?vue&type=style&index=0&id=c09c99ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09c99ca",
  null
  
)

export default component.exports